// Description: Request to save campaign data to the backend
// Updated: 08/09/2025

import axios from 'axios';
import { getTokenData } from '../../../shared/utils/utils';

export async function CampaignSave(data) {
  try {
    const { token, client_id } = await getTokenData();

    if (!token) throw new Error('Token de autenticação não encontrado');
    
    if (!client_id) throw new Error('ID do cliente não encontrado');

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/campaigns/schedule/add`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`,
          'Client_ID': `${client_id}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error saving campaign data:', error);
    throw new Error('Error saving campaign data');
  }
}
